import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface ProceduralFileResponse {
  id: string;
  name: string;
  extension: string;
  pageDimensions: { width: number; height: number }[] | null;
  url: string;
  downloadUrl: string;
}

// Presigned URLs expire in 10 minutes; cache just under that so a follow-up
// open of the same file doesn't re-fetch.
const PRESIGNED_URL_CACHE_TIME_MS = 9 * 60 * 1000;

export const useGetProceduralFile = (matterId: string | undefined, fileId: string | null) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<ProceduralFileResponse, Error>(
    [QueryEntity.ProceduralTimelineFile, { matterId, fileId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/procedural-timeline/files/${fileId}`,
        fetchConfigGET,
      );
      if (!res.ok) throw new Error('Failed to fetch procedural-timeline file');
      return res.json();
    },
    {
      enabled: !!matterId && !!fileId,
      refetchOnWindowFocus: false,
      staleTime: PRESIGNED_URL_CACHE_TIME_MS,
      cacheTime: PRESIGNED_URL_CACHE_TIME_MS,
    },
  );
};
